import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Formik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import PinForm from "./index";
import * as rk from "../../localization/resourceKeys";
import { submitPrivacyRequest } from "../../redux/MailingAddressSelector/actions";

import { clearErrors } from "../../redux/Errors/actions";

class GetPinForm extends Component {
  constructor(props) {
    super(props);
    if (!props?.verifyExperianReducer?.data?.experianTransactionId) {
      window.location.replace("/");
    }
  }

  componentDidMount(){
    this.props.clearErrors();
  }

  validate = () => {
    const { t } = this.props;
    return Yup.object().shape({
      pinNumber: Yup.string()
        .required(t(rk.ERROR_REQUIRED))
        .matches(/^\d{4}$/, t(rk.CREATE_PIN_FORM.PIN_INVALID)),
      reEnterPinNumber: Yup.string()
        .required(t(rk.ERROR_REQUIRED))
        .oneOf([Yup.ref("pinNumber")], t(rk.CREATE_PIN_FORM.PIN_DONT_MATCH)),
    });
  };

  canSubmit = (initObject, updatedObject) => {
    let allValuesChanged = true;

    for (const [key, val] of Object.entries(updatedObject)) {
      const fieldRequired = this.validate()
        .describe()
        .fields[key].tests.find((f) => f.name === "required");
      if (fieldRequired && initObject[key] === val) {
        allValuesChanged = false;
        break;
      }
    }
    return allValuesChanged;
  };

  routeOnSubmit = () => {
    const { t } = this.props;
    if (
      this.props.selectedRequest === t(rk.REQUEST_SELECTOR.ACCESS_INFO) &&
      this.props.info.reportType === t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES)
    ) {
      this.props.history.push("/formComplete", { isTier2FormComplete: true });
    } else if (this.props.selectedRequest === t(rk.REQUEST_SELECTOR.CORRECT_MY_DATA)) {
      this.props.history.push("/formComplete", { isDataCorrectionFormComplete: true});
    }
  };

  render() {
    const submitPrivacyRequestPayload = this.props.location.state
      ? this.props.location.state.submitPrivacyRequestPayload
      : "";
    return (
      <Formik
        initialValues={{
          pinNumber: "",
          reEnterPinNumber: "",
        }}
        onSubmit={async (values, { setSubmitting }) => {
          await this.props.clearErrors();
          submitPrivacyRequestPayload.requester.pin = parseInt(
            values.pinNumber
          );
          submitPrivacyRequestPayload.requester.last4Ssn =
            this.props.info.ssn.substr(5, 4);
          submitPrivacyRequestPayload.requester.fullSsn = this.props.info.ssn;
          submitPrivacyRequestPayload.isExperianVerified = this.props
            .verifyExperianReducer.data
            ? this.props.verifyExperianReducer.data.isExperianVerified
            : false;
          submitPrivacyRequestPayload.experianTransactionId = this.props
            .getExperianReducer.data
            ? this.props.getExperianReducer.data.transactionID
            : "";

          this.props.submitPrivacyRequest(
            submitPrivacyRequestPayload,
            this.routeOnSubmit,
            this.props
          );
          setSubmitting(false);
        }}
        validationSchema={this.validate()}
      >
        {(props) => {
          return (
            <PinForm
              {...props}
              networkError={this.props.networkError}
              canSubmit={this.canSubmit(props.initialValues, props.values)}
            ></PinForm>
          );
        }}
      </Formik>
    );
  }
}

GetPinForm.propTypes = {
  verifyExperianReducer: PropTypes.shape({
    data: PropTypes.shape({
      experianTransactionId: PropTypes.string,
      isExperianVerified: PropTypes.bool,
    }),
  }),
  getExperianReducer: PropTypes.shape({
    data: PropTypes.shape({
      transactionID: PropTypes.string,
    }),
  }),
  info: PropTypes.shape({
    ssn: PropTypes.string,
    reportType: PropTypes.string,
  }),
  selectedRequest: PropTypes.string,
  location: PropTypes.shape({
    state: PropTypes.shape({
      submitPrivacyRequestPayload: PropTypes.object,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  t: PropTypes.func.isRequired,
  submitPrivacyRequest: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  networkError: PropTypes.bool,
};


const mapStateToProps = (state) => ({
  info: state.info,
  selectedRequest: state.requestSelector.selectedRequest,
  verifyExperianReducer: state.verifyExperianReducer,
  getExperianReducer: state.getExperianReducer,
  networkError: state.networkError,
});

const mapDispatchToProps = (dispatch) => ({
  submitPrivacyRequest: (action, routeProps, historyProps) =>
    dispatch(submitPrivacyRequest(action, routeProps, historyProps)),
  clearErrors: () => dispatch(clearErrors()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(GetPinForm));
